import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import Tooltip, { TooltipProps } from '@atlaskit/tooltip';

import { keyboardShortcutDialogMessages } from 'src/components/keyboard-shortcut-dialog.i18n';
import { useIntl } from 'src/hooks/intl';

const KeyboardShortcutStyles = xcss({
  borderRadius: 'border.radius.050',
  backgroundColor: 'color.background.inverse.subtle.pressed',
  paddingBlock: 'space.0',
  paddingInline: 'space.050',
});

type KeyboardShortcutProps = Partial<TooltipProps> & {
  text: FormattedMessage.MessageDescriptor;
  shortcut: string;
  children: any;
};

const KeyboardShortcut = ({ shortcut }: { shortcut: string }) => (
  <Box xcss={KeyboardShortcutStyles}>{shortcut}</Box>
);

export const KeyboardShortcutTooltip = ({
  text,
  shortcut,
  children,
  ...tooltipProps
}: KeyboardShortcutProps) => {
  const intl = useIntl();
  const tooltipContent = (
    <Inline space="space.100" alignBlock="center">
      {intl.formatMessage(text)}
      <Inline space="space.050" alignBlock="center">
        {shortcut.match(/[A-Z]/) && (
          <>
            <KeyboardShortcut
              shortcut={intl.formatMessage(
                keyboardShortcutDialogMessages.shiftKey
              )}
            />
            <Text color="color.text.inverse">+</Text>
          </>
        )}
        <KeyboardShortcut shortcut={shortcut.toLowerCase()} />
      </Inline>
    </Inline>
  );
  return (
    <Tooltip content={tooltipContent} {...tooltipProps}>
      {children}
    </Tooltip>
  );
};
